<template>
  <v-list 
    dense
    v-if    = "videoController && videoController.currentAudioTrack"
  >

    <!-- Back -->
    <v-list-item @click="$emit('back')">
      <v-list-item-icon>
        <v-icon disabled>mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Audio Channels</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <div class="audio_channels_container"
         :style="containerStyle"
    >
      <!-- Channel -->
      <div class="label">Channel</div>
      <div 
        class   = "selection element" 
        v-for   = "(label, index) in labels" 
        :key    = "index" 
        @click  = "onBothSoundFields(index)"
      >
        {{ index + 1 }}
      </div>

      <!-- Label -->
      <div class="label">Label</div>
      <div
        class   = "selection element"
        v-for   = "(label, index) in labels"
        :key    = "'label_' + index"
        @click  = "onBothSoundFields(index)"
      >
        {{ label }}
      </div>

      <!-- Label -->
      <div 
        v-if    = "mappedLabels" 
        class   = "label"
      >
        Mapped
      </div>
      <div
        class   = "selection element"
        v-for   = "(label, index) in mappedLabels"
        :key    = "'mapped_label_' + index"
        @click  = "onBothSoundFields(index)"
      >
        {{ label }}
      </div>

      <!-- Left Output -->
      <div class="label">Left Output</div>
      <div
        class   = "selection element"
        v-for   = "(selection, index) in selections"
        :key    = "'left_' + index"
        @click  = "onLeftSoundField(index)"
      >
        <v-icon :disabled="isSurround">{{ selection.left ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
      </div>

      <!-- Right Output -->
      <div class="label">Right Output</div>
      <div
        class   = "selection element"
        v-for   = "(selection, index) in selections"
        :key    = "'right_' + index"
        @click  = "onRightSoundField(index)"
      >
        <v-icon :disabled="isSurround">{{ selection.right ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
      </div>

      <!-- Surround -->
      <div v-if="hasSurround"
           class="label"
      >Surround</div>
      <v-switch
        v-if    = "hasSurround"
        dark
        color   = "primary"
        hide-details
        dense
        class   = "mt-0 surround"
        :input-value="isSurround"
        @change = "onSurroundSoundField"
      >
      </v-switch>
    </div>
  </v-list>
</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { MODIFY_AUDIO_SOUND_FIELD } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  name:     'AudioChannelsMenu',
  computed: {
    ...mapState(['videoController']),
    containerStyle() {
      return {
        'grid-template-columns': `90px repeat(${this.videoController.currentAudioTrack.channelLabels.length}, 40px)`
      };
    },
    hasSurround() {
      return this.videoController.currentAudioTrack.soundfields.has('Surround');
    },
    isSurround() {
      return this.videoController.currentAudioTrack.currentSoundfield === 'Surround';
    },
    labels() {
      return this.videoController.currentAudioTrack.channelLabels;
    },
    mappedLabels() {
      return this.videoController.currentAudioTrack.mappedChannelLabels;
    },
    selections() {
      return this.labels.map(
        (label, index) => {
          return {
            left:  !this.isSurround && (this.videoController.currentAudioTrack.left === index),
            right: !this.isSurround && (this.videoController.currentAudioTrack.right === index)
          };
        }
      );
    }
  },

  // #endregion Properties

  // #region Events

  methods: {

    onLeftSoundField(index) {
      this.$store.dispatch(
        MODIFY_AUDIO_SOUND_FIELD,
        {
          soundField: 'Stereo',
          left:       index,
          right:      this.videoController.currentAudioTrack.right
        }
      );
    },

    onRightSoundField(index) {
      this.$store.dispatch(
        MODIFY_AUDIO_SOUND_FIELD,
        {
          soundField: 'Stereo',
          left:       this.videoController.currentAudioTrack.left,
          right:      index
        }
      );
    },

    onBothSoundFields(index) {
      this.$store.dispatch(
        MODIFY_AUDIO_SOUND_FIELD,
        {
          soundField: 'Stereo',
          left:       index,
          right:      index
        }
      );
    },

    onSurroundSoundField(isEnabled) {
      if (isEnabled) {
        this.$store.dispatch(
          MODIFY_AUDIO_SOUND_FIELD,
          {
            soundField: 'Surround'
          }
        );
      } else {
        this.$store.dispatch(
          MODIFY_AUDIO_SOUND_FIELD,
          {
            soundField: 'Stereo',
            left:       this.videoController.currentAudioTrack.left,
            right:      this.videoController.currentAudioTrack.right
          }
        );
      }
    }

  }

  // #endregion Events

}
</script>

<style lang="scss" scoped>
.audio_channels_container {
  display: grid;
  row-gap: 4px;
  overflow-y: auto;

  padding: 8px 8px 8px 0px;
  font-size: 0.9em;

  .label {
    position: sticky;
    left: 0;
    z-index: 1;
    text-align: right;
    padding: 2px 4px;
    background-color: #1e1e1e; // TODO
  }

  .element {
    text-align: center;
    padding: 2px 0px;

    &.selection {
      cursor: pointer;
      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 2px;
      }
    }
  }

  .surround {
    position: sticky;
    left: 100px;
  }
}
</style>
